module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('div', {
    staticClass: "bxgrn"
  }, [_c('p', {
    staticClass: "cop_7"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page4",
      "title": "4"
    }
  }, [_vm._v("Copyright © 2015 by Kathy Patalsky")])]), _vm._v(" "), _c('p', {
    staticClass: "cop"
  }, [_vm._v("Interior photography © 2015 by Kathy Patalsky")]), _vm._v(" "), _c('p', {
    staticClass: "cop"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "cop1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to trade.permissions@hmhco.com or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "cop1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cop1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data is available upon request. ")]), _vm._v(" "), _c('p', {
    staticClass: "cop"
  }, [_vm._v("ISBN 978-0-544-37980-0 (pbk.); 978-0-544-37696-0 (ebk.)")]), _vm._v(" "), _c('p', {
    staticClass: "cop1"
  }, [_vm._v("Design by Amy Sly")]), _vm._v(" "), _c('p', {
    staticClass: "cop1"
  }, [_vm._v("v1.0415")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e48b77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/cop.vue
// module id = 63
// module chunks = 0